import { IVideoOverlay } from './IVideoOverlay';
import { VgStates } from '../videogular/VgStates';
import { getDomElement, isElementVisibleOnDom, normalizeHtml } from './HtmlUtil';

export class VideoOverlay implements IVideoOverlay {
	public id: number;
	public content: string;
	public start?: number | VgStates;
	public end?: number | VgStates;
	public forcedOverlayRecreation?: boolean;
	public cssClasses?: string[];
	public recreationTriggerIds?: string[];

	private overlayDiv: HTMLElement;
	private intervalRef: number;
	private isWindowReloading: boolean;
	private initialContent: string;

	private unload = () => {
		this.isWindowReloading = true;
	}

	constructor(data: IVideoOverlay, private parentElement: HTMLElement) {
		Object.assign(this, data);
	}

	public constructOverlay(): void {
		if (this.intervalRef) {
			window.clearInterval(this.intervalRef);
		}

		this.createElement();
		this.parentElement.appendChild(this.overlayDiv);

		if (this.forcedOverlayRecreation) {
			this.intervalRef = window.setInterval(() => this.checkToRecreateElement(), 250);

			window.addEventListener('beforeunload', this.unload);
		}
	}

	public destroyOverlay(): void {
		if (this.intervalRef) {
			window.clearInterval(this.intervalRef);
			window.removeEventListener('beforeunload', this.unload);
		}
		this.parentElement.removeChild(this.overlayDiv);
	}

	private createElement(): void {
		let newEle: HTMLElement;

		if (this.overlayDiv && getDomElement(this.overlayDiv?.id)) {
			newEle = this.overlayDiv;
		} else {
			newEle = document.createElement('overlay-magic-ele');
			newEle.id = `overlay-${this.id}`;
		}

		newEle.innerHTML = this.content;

		//because of the way innerHTML works, we need to store the initial content coming from innerHTML to compare later.
		this.initialContent = newEle.innerHTML;

		if (this.cssClasses?.length) {
			newEle.classList.add(...this.cssClasses);
		}

		this.overlayDiv = newEle;
	}

	private checkToRecreateElement(): void {
		if (this.isWindowReloading) {
			return;
		}

		const domHtml = normalizeHtml(getDomElement(this.overlayDiv?.id)?.innerHTML);
		const originalHtml = normalizeHtml(this.initialContent);

		if (domHtml !== originalHtml
			|| this.recreationTriggerIds?.some(id => !isElementVisibleOnDom(getDomElement(id)))) {

			console.warn(`overlay recreated`);
			window.location.reload();
		}
	}

}
